import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=16b862e7&scoped=true&"
import script from "./Development.vue?vue&type=script&lang=js&"
export * from "./Development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b862e7",
  null
  
)

export default component.exports